import {LoadingButton} from '@mui/lab';
import {Button} from '@mui/material';
import {get, isEqual} from 'lodash';
import {FC, Fragment, useMemo, useRef} from 'react';
import {useRecoilValue} from 'recoil';
import {useFiltersSetsRefresh, usePutFiltersSets} from '../../../../global/services/filters-sets';
import {authState} from '../../../../store/auth/atoms';
import {entriesToFilters} from '../../helpers/entries-to-filters';
import {
  contractTableFiltersEditModalClose,
  useContractTableFiltersEditModalStore,
} from '../../stores/contract-table-filters-edit-modal.store';
import {ContractModal} from '../contract-modal';
import {ContractsTableFiltersModalForm, ContractsTableFiltersModalFormRef} from './contracts-table-filters-moda-forml';

export const ContractsTableEditFiltersModal: FC = () => {
  const ref = useRef<ContractsTableFiltersModalFormRef>(null);
  const editableFilter = useContractTableFiltersEditModalStore((s) => s.editableFilter);
  const {user} = useRecoilValue(authState);
  const {mutate, loading} = usePutFiltersSets();
  const refreshFiltersSets = useFiltersSetsRefresh();
  const defaultValues = {name: editableFilter?.name || ''};

  const handleClose = () => {
    ref.current?.form.reset(defaultValues);
    contractTableFiltersEditModalClose();
  };

  const afterMutateCallback = () => {
    refreshFiltersSets();
    handleClose();
  };

  const handleFormSubmit = async () => {
    if (!editableFilter || !ref.current?.form) return;
    const form = ref.current.form;
    const isValid = await form.trigger();

    if (!isValid) return;

    const name = form.getValues('name');

    if (isEqual(name, editableFilter.name)) {
      form.setError('name', {type: 'custom', message: 'Имя не изменено'});
      return;
    }

    await mutate([{...editableFilter, userUid: get(user, 'uid', ''), name}], afterMutateCallback);
  };

  const filters = useMemo(() => {
    try {
      return entriesToFilters(JSON.parse(editableFilter?.filters || ''));
    } catch {
      return [];
    }
  }, [editableFilter?.filters]);

  return (
    <ContractModal
      title="Сохранение фильтра"
      open={!!editableFilter}
      footer={
        <Fragment>
          <Button variant="outlined" color="error" onClick={handleClose}>
            Отменить
          </Button>
          <LoadingButton variant="contained" onClick={handleFormSubmit} loading={loading}>
            Сохранить
          </LoadingButton>
        </Fragment>
      }
    >
      <ContractsTableFiltersModalForm ref={ref} defaultValues={defaultValues} filters={filters} />
    </ContractModal>
  );
};
